require('./cardPayLaterStep1.scss');

const PropTypes = require('prop-types');

// @ vendor
const React = require('react');
const { connect } = require('react-redux');
// @ actions
const cardPayLaterActions = require('actions/cardPayLater');
// @ helpers
const { FormattedText, formatText, getLanguage } = require('core/i18n').i18n;
const { getCurrencySymbol } = require('utilities/currencyHelper');
// @ commons
const OKModal = require('components/commons/OKModal/OKModal');
const { AmountInput } = require('commonsComponents/amountInput');
// @ components
const CardPayLaterInformation = require('components/cards/cardPayLaterSteps/cardPayLaterInformation/cardPayLaterInformation');

class CardPayLaterStep1 extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            informationModalOpen: false
        };

        this.handleMoreInformationModalToggle = this.handleMoreInformationModalToggle.bind(this);
    }

    buildMoreInformationModal() {
        const modalContent = (
            <div className="card-pay-later-step-one__modal">
                <h5>
                    <FormattedText value="cardPayLater-cardPayLater_infoTitle" />
                </h5>
                <ul>
                    <li className="card-pay-later-step-one__modal-item"><FormattedText value="cardPayLater-infoMessage0" /></li>
                    <li className="card-pay-later-step-one__modal-item">
                        <FormattedText value="cardPayLater-infoMessage1" />
                        <ul>
                            <li className="card-pay-later-step-one__modal-item"><FormattedText value="cardPayLater-infoMessage2" /></li>
                            <li className="card-pay-later-step-one__modal-item"><FormattedText value="cardPayLater-infoMessage3" /></li>
                        </ul>
                    </li>
                    <li className="card-pay-later-step-one__modal-item"><FormattedText value="cardPayLater-infoMessage4" /></li>
                </ul>
            </div>
        );

        return (
            <OKModal
                content={modalContent}
                isOpen={this.state.informationModalOpen}
                onCloseCallback={this.handleMoreInformationModalToggle}
                size="large"
                title="cardPayLater-payLater"
                titleAlignment="center"
            />
        );
    }

    handleMoreInformationModalToggle() {
        this.setState({
            informationModalOpen: !this.state.informationModalOpen
        });
    }

    render() {
        const { immCard, immCardPayLater, immGlobalVariables, setImport } = this.props;
        const immStep = immCardPayLater.getIn(['steps', 0]);
        const disposedBalance = immCard.get('balanceDrawn');
        const currencySymbol = getCurrencySymbol(disposedBalance);
        const moreInformationModal = this.buildMoreInformationModal();
        const labelImport = formatText('cardPayLater-import');
        const importAlertVisible = !immStep.get('valid') && immStep.get('isDirty');
        const importErrorMsg = formatText('cardPayLater-inputHelpMessage', [`${immStep.get('importMin')} ${currencySymbol}`, `${immStep.get('importMax')} ${currencySymbol}`, currencySymbol]);

        let inputHelpContent;
        if (!importAlertVisible) {
            inputHelpContent = (
                <div className="card-pay-later-step-one__input-help-text">
                    {importErrorMsg}
                </div>
            );
        }

        return (
            <section className="card-pay-later-step-one">
                <article className="card-pay-later-step-one__section">
                    <header className="card-pay-later-step-one__header">
                        <FormattedText
                            value="cardPayLater-title"
                            className="card-pay-later-step-one__title"
                        />
                    </header>
                    <section className="card-pay-later-step-one__content">
                        <div className="row card-pay-later-step-one__subsection">
                            <div className="col-xs-12">
                                <FormattedText
                                    value="cardPayLater-delayPaymentMessage"
                                    className="card-pay-later-step-one__delay-payment"
                                />
                            </div>
                        </div>

                        <div className="card-pay-later-step-one__subsection">
                            <div className="col-xs-12">
                                <CardPayLaterInformation
                                    immCard={immCard}
                                    immCardPayLater={immCardPayLater}
                                    immGlobalVariables={immGlobalVariables}
                                />
                            </div>
                        </div>

                        <div className="row card-pay-later-step-one__subsection">
                            <div className="col-xs-6">
                                <div className="card-pay-later-step-one__import">
                                    <label id="lbl_inp_CardPayLaterStep1_Import" className="ok-input__label">
                                        {labelImport}
                                    </label>
                                    <AmountInput
                                        id="inp_CardPayLaterStep1_Import"
                                        callback={setImport}
                                        min={0}
                                        error={importAlertVisible}
                                        errorMsg={importErrorMsg}
                                        amount={immStep.get('import')}
                                        showBlurZero
                                        hideFocusZero
                                        disablePaste
                                        language={getLanguage()}
                                    />
                                </div>
                                <div className="card-pay-later-step-one__currency-symbol">
                                    {currencySymbol}
                                </div>
                                {inputHelpContent}
                            </div>
                        </div>

                    </section>
                </article>

                {moreInformationModal}
            </section>
        )
    }
}

CardPayLaterStep1.propTypes = {
    immCardPayLater: PropTypes.object,
    immCard: PropTypes.object,
    immGlobalVariables: PropTypes.object,
    import: PropTypes.any,
    setImport: PropTypes.func
};

module.exports.constructor = CardPayLaterStep1;
module.exports.CardPayLaterStep1 = connect(null,
    {
        setImport: cardPayLaterActions.setImport
    }
)(CardPayLaterStep1);
